import Footer from '@tcs/create-account/components/Footer';
import Header from '@tcs/create-account/components/Header';
import ContentContainer from '@tcs/create-account/containers/ContentContainer';
import SeoHeadTags from '@tcs/create-account/containers/SeoHeadTags';
import SlicePicker from '@tcs/create-account/containers/SlicePicker';
import { Helmet } from 'react-helmet';
import { useStyles } from './style';

const LandingPageComposition = ({ header, page, footer }) => {
  const { body, page_heading, seo_title } = page;
  const classes = useStyles();

  return (
    <>
      {/* @ts-ignore */}
      <Helmet>
        <title>{seo_title}</title>
        <SeoHeadTags page={page} />
      </Helmet>

      <Header data={header} />
      <div data-test="create-account-landing">
        <ContentContainer>
          <h1 className={classes.heading}>{page_heading}</h1>
          <div>
            <SlicePicker list={body} />
          </div>
        </ContentContainer>
      </div>

      <Footer data={footer} />
    </>
  );
};

export default LandingPageComposition;
